export default {
  //Container where all feature tags are included
  FEATURE_ORDER_CAPTURE: "orderCapture",
  FEATURE_PRICING_ENGINE: "pricingEngine",
};
